import { I18n } from 'react-redux-i18n'

export default (billing) => {
  let errors = {}

  if (billing.type === 'flight') {
    if (billing.rows.every((item) => !item.locatorFlight || !item.airline)) {
      errors.rows = I18n.t('dashboard_errors_required-field')
    }
  } else if (billing.type === 'hotel') {
    if (billing.rows.every((item) => !item.locatorHotel)) {
      errors.rows = I18n.t('dashboard_errors_required-field')
    }
  } else if (billing.type === 'insurance') {
    if (billing.rows.every((item) => !item.locatorInsurance || !item.policy)) {
      errors.rows = I18n.t('dashboard_errors_required-field')
    }
  }

  return errors
}
